// extracted by mini-css-extract-plugin
module.exports = {"fixed_popup_container":"fixed_popup_fixed_popup_container__tiomB"};